module.exports = __webpack_public_path__ + "img/fr.ad12a30f.svg";